import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Grid,
  Box,
  Button,
  Container,
  Fade,
  Zoom,
} from "@mui/material";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import "./brand.css";
import FooterManual from "./footerManual";
import Notes from "./header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faFire, faStar, faCar } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

export default function MultiActionAreaCard() {
  const [carBrands, setCarBrands] = useState([]);
  const [carModels, setCarModels] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const brandName =
    params.brandName ||
    (location.state && location.state.brandName ? location.state.brandName : null);
    const filterStateFromNav = location.state?.filterState || null;

  useEffect(() => {
    const brandName =
      params.brandName ||
      (location.state && location.state.brandName ? location.state.brandName : null);

    if (brandName) {
      setSelectedBrand(brandName);
      if (location.state && location.state.models) {
        setCarModels(location.state.models);
        setLoading(false);
      } else {
        fetchModelsByBrand(brandName);
      }
    } else {
      fetchAllBrands();
    }
  }, [brandName, location.state]);

  const fetchModelsByBrand = (brand) => {
    setLoading(true);
    axios
      .get(
        `https://car.amar.co.jp/api/dashboard/product/get/unique/models/by-brand-name?brandName=${encodeURIComponent(
          brand
        )}`
      )
      .then((response) => {
        if (response.data && response.data.code === 200) {
          setCarModels(response.data.models || []);
        } else {
          setError(`Failed to get models for ${brand}`);
        }
        setLoading(false);
      })
      .catch((err) => {
        setError(`Error fetching models for ${brand}: ${err.message}`);
        setLoading(false);
      });
  };

  const fetchAllBrands = () => {
    setLoading(true);
    axios
      .get("https://car.amar.co.jp/api/master/car-brand/get-all-brandName")
      .then((response) => {
        if (response.data && response.data.code === 200) {
          const sortedBrands = response.data.carBrandList.sort((a, b) =>
            a.carBrandName.localeCompare(b.carBrandName)
          );
          setCarBrands(sortedBrands);
        } else {
          setError("Failed to get car brands data");
        }
        setLoading(false);
      })
      .catch((err) => {
        setError("Error fetching car brands: " + err.message);
        setLoading(false);
      });
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  const popularBrands = [
    "TOYOTA",
    "FORD",
    "AUDI",
    "GMC",
    "BMW",
    "NISSAN",
    "SAAB",
    "VOLVO",
    "PORSCHE",
    "VOLKSWAGEN",
  ];

  const brandImages = {
    TOYOTA: "/BrandIcons/Brand_Toyota.svg",
    FORD: "/BrandIcons/Brand_Ford.svg",
    AUDI: "/BrandIcons/Brand_Audi.svg",
    GMC: "/BrandIcons/Brand_GMC.svg",
    BMW: "/BrandIcons/Brand_BMW.svg",
    NISSAN: "/BrandIcons/Brand_Nissan.svg",
    SAAB: "/BrandIcons/Brand_Saab.svg",
    VOLVO: "/BrandIcons/Brand_Volvo.svg",
    PORSCHE: "/BrandIcons/Brand_Porsche.svg",
    VOLKSWAGEN: "/BrandIcons/Brand_Volkswagen.svg",
  };

  const allBrandImages = (brandName) => {
    const imageMap = {
      ALFAROMEO: "/BrandIcons/Brand_Alfa_Romeo.svg",
      ALPINA: "/BrandIcons/Brand_Alpina.svg",
      AMG: "/BrandIcons/Brand_AMG.svg",
      "ASTON MARTIN": "/BrandIcons/Brand_Aston_Martin.svg",
      AUDI: "/BrandIcons/Brand_Audi.svg",
      BENTLEY: "/BrandIcons/Brand_Bentley.svg",
      BMW: "/BrandIcons/Brand_BMW.svg",
      CADILLAC: "/BrandIcons/Brand_Cadillac.svg",
      CHEVROLET: "/BrandIcons/Brand_Chevrolet.svg",
      CHRYSLER: "/BrandIcons/Brand_Chrysler.svg",
      CITROEN: "/BrandIcons/Brand_Citroen.svg",
      DAIHATSU: "/BrandIcons/Brand_Daihatsu.svg",
      DAIMLER: "/BrandIcons/Brand_Daimler.svg",
      DODGE: "/BrandIcons/Brand_Dodge.svg",
      "ENGLAND Others": "/BrandIcons/Brand_Daimler.svg",
      FERRARI: "/BrandIcons/Brand_Ferrari.svg",
      FIAT: "/BrandIcons/Brand_Fiat.svg",
      FORD: "/BrandIcons/Brand_Ford.svg",
      GMC: "/BrandIcons/Brand_GMC.svg",
      HINO: "/BrandIcons/Brand_Hino.svg",
      HONDA: "/BrandIcons/Brand_Honda.svg",
      HUMMER: "/BrandIcons/Brand_Hummer.svg",
      HYUNDAI: "/BrandIcons/Brand_Hyundai.svg",
      INFINITY: "/BrandIcons/Brand_Infiniti.svg",
      ISUZU: "/BrandIcons/Brand_Isuzu.svg",
      JAGUAR: "/BrandIcons/Brand_Jaguar.svg",
      JEEP: "/BrandIcons/Brand_Jeep.svg",
      LAMBORGHINI: "/BrandIcons/Brand_Lamborghini.svg",
      LANCIA: "/BrandIcons/Brand_Lancia-50.svg",
      LAND_ROVER: "/BrandIcons/Brand_Land Rover.svg",
      LEXUS: "/BrandIcons/Brand_Lexus.svg",
      LINCOLN: "/BrandIcons/Brand_Lincoln.svg",
      LOTUS: "/BrandIcons/Brand_Lotus.svg",
      MASERATI: "/BrandIcons/Brand_Maserati.svg",
      MAZDA: "/BrandIcons/Brand_Mazda.svg",
      MCC: "/BrandIcons/Brand_Daimler.svg",
      MERCEDES: "/BrandIcons/Brand_Mercedes.svg",
      MINI: "/BrandIcons/Brand_Mini.svg",
      MITSUBISHI: "/BrandIcons/Brand_Fuso.svg",
      "MITSUBISHI FUSOU": "/BrandIcons/Brand_Fuso.svg",
      MITSUOKA: "/BrandIcons/Brand_Matsuoka.svg",
      NISSAN: "/BrandIcons/Brand_Nissan.svg",
      "NISSAN DIESEL": "/BrandIcons/Brand_Nissan.svg",
      OPEL: "/BrandIcons/Brand_Opel.svg",
      PEUGEOT: "/BrandIcons/Brand_Peugeot.svg",
      PORSCHE: "/BrandIcons/Brand_Porsche.svg",
      RENAULT: "/BrandIcons/Brand_Renault.svg",
      "ROLLS-ROYCE": "/BrandIcons/Brand_Rolls Royce.svg",
      ROVER: "/BrandIcons/Brand_Land Rover.svg",
      SAAB: "/BrandIcons/Brand_Saab.svg",
      SEAT: "/BrandIcons/Brand_Seat.svg",
      SMART: "/BrandIcons/Brand_Smart.svg",
      SUBARU: "/BrandIcons/Brand_Saabaru.svg",
      SUZUKI: "/BrandIcons/Brand_Suzuki.svg",
      TOYOTA: "/BrandIcons/Brand_Toyota.svg",
      VOLKSWAGEN: "/BrandIcons/Brand_Volkswagen.svg",
      VOLVO: "/BrandIcons/Brand_Volvo.svg",
      ASTONMARTIN: "/BrandIcons/Brand_Aston_Martin.svg",
      "MERCEDES BENZ": "/BrandIcons/Brand_Mercedes.svg",
      MYBACH: "/BrandIcons/Brand_Mercedes.svg",
      TESLA: "/BrandIcons/Brand_Tesla.svg",
      Others: "/BrandIcons/Brand_Others.svg",
      AUTOBIANCHI: "/BrandIcons/Brand_Autobianchi.svg",
      BRABUS: "/BrandIcons/Brand_Brabus.svg",
      BYD: "/BrandIcons/Brand_BYD.svg",
      MOKE: "/BrandIcons/Brand_MOKE.svg",
      PONTIAC: "/BrandIcons/Brand_PONTIAC.svg",
    };

    return imageMap[brandName] || "/images/default.png";
  };

  // const handleBrandClick = (brandName) => {
  //   navigate(`/brand/${encodeURIComponent(brandName)}`);
  // };
  const handleBrandClick = (brandName) => {
    navigate(`/brand/${encodeURIComponent(brandName)}`, {
      state: {
        filterState: {
          selectedBrand: { label: brandName },
          selectedCategory: null,
          selectedModels: [],
          selectedYears: [],
        },
      },
    });
  };

  // const handleModelClick = (modelName) => {
  //   navigate(
  //     `/model/${encodeURIComponent(selectedBrand)}/${encodeURIComponent(modelName)}`
  //   );
  // };

  // const handleModelClick = (modelName) => {
  //   navigate(
  //     `/model/${encodeURIComponent(selectedBrand)}/${encodeURIComponent(modelName)}`,
  //     { state: { brandName: selectedBrand } }  // 👈 sirf yeh line add ki
  //   );
  // };

  const handleModelClick = (modelName) => {
  navigate(
    `/model/${encodeURIComponent(selectedBrand)}/${encodeURIComponent(modelName)}`,
    {
      state: {
        brandName: selectedBrand,
        // filterState aage bhi pass karo taaki model page pe bhi kaam aaye
        filterState: filterStateFromNav || {
          selectedBrand: { label: selectedBrand },
          selectedCategory: null,
          selectedModels: [],
          selectedYears: [],
        },
      },
    }
  );
};

  // Render brand models view if a specific brand is selected
  if (selectedBrand) {
    return (
      <Box sx={{ width: "100%", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
        <Notes />

        {/* Hero Banner */}
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: { xs: "30vh", sm: "40vh", md: "50vh" },
            backgroundColor: "black",
            overflow: "hidden",
          }}
        >
          <Box
            component="img"
            src="/images/bg.png"
            alt="banner"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              opacity: 0.57,
            }}
          />

          {/* Breadcrumb */}
          <Box
            sx={{
              position: "absolute",
              top: { xs: "5%", sm: "8%", md: "10%" },
              left: { xs: "3%", sm: "5%", md: "5%" },
              color: "white",
              fontSize: { xs: "11px", sm: "13px", md: "15px" },
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              padding: { xs: "4px 8px", sm: "5px 10px", md: "5px 10px" },
              borderRadius: "5px",
              display: "flex",
              gap: { xs: "2px", sm: "5px", md: "5px" },
              flexWrap: "wrap",
            }}
          >
            <Link
              to="https://car.amar.co.jp/"
              style={{
                fontSize: "inherit",
                color: "white",
                textDecoration: "none",
                opacity: 0.7,
              }}
            >
              Home
            </Link>
            <span style={{ opacity: 0.7 }}>/</span>
            <Link
              to="/brand"
              style={{
                fontSize: "inherit",
                color: "white",
                textDecoration: "none",
                opacity: 0.7,
              }}
            >
              All Brands
            </Link>
            <span style={{ opacity: 0.7 }}>/</span>
            <span>{selectedBrand.replace(/_/g, " ")}</span>
          </Box>

          {/* Title */}
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "white",
              fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
              textAlign: "center",
              fontWeight: 700,
              textShadow: "2px 2px 8px rgba(0, 0, 0, 0.5)",
              width: "90%",
            }}
          >
            {selectedBrand.replace(/_/g, " ")} Models
          </Box>
        </Box>

        {/* Main Content Container */}
        <Container
          maxWidth="xl"
          sx={{
            width: "90%",
            backgroundColor: "#FFFFFF",
            border: "2px solid #EBEBEB",
            borderRadius: "10px",
            marginTop: { xs: "-40px", sm: "-50px", md: "-75px" },
            marginBottom: { xs: "50px", sm: "75px", md: "100px" },
            position: "relative",
            zIndex: 1,
            p: { xs: 2, sm: 3, md: 4 },
          }}
        >
          {/* Header Section */}
          <Box sx={{ mb: { xs: 2, sm: 3, md: 4 } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
                color: "#333",
                mb: 1,
              }}
            >
              {selectedBrand.replace(/_/g, " ")} Car Models
            </Typography>
            <Box
              sx={{
                width: { xs: "50px", sm: "60px", md: "80px" },
                height: "4px",
                background: "linear-gradient(45deg, #ff0037, #0066ff)",
                borderRadius: "2px",
              }}
            />
          </Box>

          {/* Models Grid */}
          {carModels.length > 0 ? (
            <Grid container spacing={{ xs: 2, sm: 2.5, md: 3 }}>
              {carModels.map((model, index) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={`model-${index}`}>
                  <Zoom in={true} style={{ transitionDelay: `${index * 100}ms` }}>
                    <Card
                      sx={{
                        cursor: "pointer",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        backgroundColor: "#fff",
                        border: "2px solid #ebebeb",
                        borderRadius: "10px",
                        transition: "all 0.3s ease-in-out",
                        "&:hover": {
                          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.12)",
                          transform: "translateY(-4px)",
                          borderColor: "#EB2329",
                        },
                      }}
                      onClick={() => handleModelClick(model.modelName || model)}
                    >
                      <CardMedia
                        component="img"
                        sx={{
                          height: { xs: "120px", sm: "140px", md: "160px" },
                          objectFit: "contain",
                          padding: { xs: "10px", sm: "15px", md: "20px" },
                        }}
                        image={allBrandImages(selectedBrand.toUpperCase())}
                        alt={`${selectedBrand} ${model.modelName || model}`}
                      />
                      <CardContent
                        sx={{
                          textAlign: "center",
                          p: { xs: 1.5, sm: 2, md: 2 },
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" },
                            color: "#333",
                            mb: 1.5,
                          }}
                        >
                          {model.modelName || model}
                        </Typography>
                        <Button
                          variant="contained"
                          sx={{
                            background: "linear-gradient(45deg, #ff0037, #ff3366)",
                            color: "white",
                            textTransform: "none",
                            fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.9rem" },
                            padding: { xs: "6px 12px", sm: "8px 16px", md: "8px 16px" },
                            borderRadius: "20px",
                            fontWeight: 600,
                            transition: "all 0.3s ease",
                            "&:hover": {
                              background: "linear-gradient(45deg, #cc0029, #ff0037)",
                              transform: "translateY(-2px)",
                            },
                          }}
                        >
                          View Details
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            style={{ marginLeft: "8px", fontSize: "0.7rem" }}
                          />
                        </Button>
                      </CardContent>
                    </Card>
                  </Zoom>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                margin: { xs: "30px 0", sm: "50px 0", md: "50px 0" },
                color: "#666",
              }}
            >
              No models found for {selectedBrand.replace(/_/g, " ")}
            </Typography>
          )}

          {/* Back Button */}
          <Box sx={{ display: "flex", justifyContent: "center", margin: { xs: "20px 0", sm: "30px 0", md: "30px 0" } }}>
            <Button
              variant="contained"
              onClick={() => navigate("/brand")}
              sx={{
                background: "linear-gradient(45deg, #ff0037, #ff3366)",
                color: "white",
                borderRadius: "24px",
                padding: { xs: "8px 20px", sm: "10px 24px", md: "10px 24px" },
                textTransform: "none",
                fontWeight: 600,
                fontSize: { xs: "0.85rem", sm: "0.95rem", md: "1rem" },
                transition: "all 0.3s ease",
                "&:hover": {
                  background: "linear-gradient(45deg, #cc0029, #ff0037)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 12px rgba(235, 35, 41, 0.3)",
                },
              }}
            >
              Back to All Brands
            </Button>
          </Box>
        </Container>

        <Box sx={{ mt: { xs: "20%", sm: "15%", md: "10%", lg: "5%" } }}>
          <FooterManual />
        </Box>
      </Box>
    );
  }

  // All Brands View
  const filteredPopularBrands = carBrands.filter((brand) =>
    popularBrands.includes(brand.carBrandName.toUpperCase())
  );

  const nonPopularBrands = carBrands.filter(
    (brand) => !popularBrands.includes(brand.carBrandName.toUpperCase())
  );

  return (
    <Box sx={{ width: "100%", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Notes />

      {/* Hero Banner */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: "30vh", sm: "40vh", md: "50vh" },
          backgroundColor: "black",
          overflow: "hidden",
        }}
      >
        <Box
          component="img"
          src="/images/bg.png"
          alt="banner"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: 0.57,
          }}
        />

        {/* Breadcrumb */}
        <Box
          sx={{
            position: "absolute",
            top: { xs: "5%", sm: "8%", md: "10%" },
            left: { xs: "3%", sm: "5%", md: "5%" },
            color: "white",
            fontSize: { xs: "11px", sm: "13px", md: "15px" },
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            padding: { xs: "4px 8px", sm: "5px 10px", md: "5px 10px" },
            borderRadius: "5px",
            display: "flex",
            gap: { xs: "2px", sm: "5px", md: "5px" },
          }}
        >
          <Link
            to="https://car.amar.co.jp/"
            style={{
              fontSize: "inherit",
              color: "white",
              textDecoration: "none",
              opacity: 0.7,
            }}
          >
            Home
          </Link>
          <span style={{ opacity: 0.7 }}>/</span>
          <span>All Brands</span>
        </Box>

        {/* Title */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
            textAlign: "center",
            fontWeight: 700,
            textShadow: "2px 2px 8px rgba(0, 0, 0, 0.5)",
            width: "90%",
          }}
        >
          Explore <span style={{ color: "#EB2329" }}>Car Brands</span>
        </Box>
      </Box>

      {/* Main Content Container */}
      <Container
        maxWidth="xl"
        sx={{
          width: "90%",
          backgroundColor: "#FFFFFF",
          border: "2px solid #EBEBEB",
          borderRadius: "10px",
          marginTop: { xs: "-75px", sm: "-50px", md: "-75px" },
          marginBottom: { xs: "50px", sm: "75px", md: "100px" },
          position: "relative",
          zIndex: 1,
          p: { xs: 2, sm: 3, md: 4 },
        }}
      >
        {/* Popular Brands Section */}
        <Fade in={true} timeout={800}>
          <Box>
            <Box sx={{ mb: { xs: 2, sm: 3, md: 4 } }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: { xs: 1, sm: 1.5, md: 2 },
                  mb: 2,
                }}
              >
                <FontAwesomeIcon
                  icon={faFire}
                  style={{
                    fontSize: "1.5rem",
                    color: "#ff0037",
                  }}
                />
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
                    color: "#333",
                  }}
                >
                  Popular Car Brands
                </Typography>
              </Box>
              <Box
                sx={{
                  width: { xs: "50px", sm: "60px", md: "80px" },
                  height: "4px",
                  background: "linear-gradient(45deg, #ff0037, #0066ff)",
                  borderRadius: "2px",
                  mb: 1,
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: "#666",
                  fontSize: { xs: "0.85rem", sm: "0.95rem", md: "1rem" },
                }}
              >
                Most sought-after automotive brands
              </Typography>
            </Box>

            <Grid container spacing={{ xs: 2, sm: 2.5, md: 3 }} sx={{ mb: { xs: 4, sm: 5, md: 6 } }}>
              {filteredPopularBrands.map((brand, index) => (
                <Grid item xs={6} sm={4} md={3} lg={2.4} key={`popular-${index}`}>
                  <Zoom in={true} style={{ transitionDelay: `${index * 100}ms` }}>
                    <Card
                      className="popular-brand-card"
                      onClick={() => handleBrandClick(brand.carBrandName)}
                      sx={{
                        cursor: "pointer",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "center",
                        backgroundColor: "#fff",
                        border: "2px solid #e9ecef",
                        borderRadius: "15px",
                        padding: { xs: 1.5, sm: 2, md: 2 },
                        transition: "all 0.3s ease-in-out",
                        "&:hover": {
                          boxShadow: "0 8px 20px rgba(255, 0, 55, 0.2)",
                          transform: "translateY(-4px)",
                          borderColor: "#ff0037",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                          background: "linear-gradient(45deg, #ff0037, #ff3366)",
                          color: "white",
                          width: "28px",
                          height: "28px",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "0.7rem",
                        }}
                      >
                        <FontAwesomeIcon icon={faStar} />
                      </Box>

                      <CardMedia
                        component="img"
                        sx={{
                          height: { xs: "40px", sm: "50px", md: "60px" },
                          width: "auto",
                          objectFit: "contain",
                          mb: 1,
                        }}
                        image={brandImages[brand.carBrandName.toUpperCase()] || "/images/default.png"}
                        alt={brand.carBrandName}
                      />
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 700,
                          fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.95rem" },
                          color: "#333",
                          textAlign: "center",
                          textTransform: "uppercase",
                          mb: 1,
                        }}
                      >
                        {brand.carBrandName.replace(/_/g, " ")}
                      </Typography>
                      <Button
                        variant="contained"
                        sx={{
                          background: "linear-gradient(45deg, #ff0037, #ff3366)",
                          color: "white",
                          textTransform: "none",
                          fontSize: { xs: "0.65rem", sm: "0.75rem", md: "0.8rem" },
                          padding: { xs: "4px 8px", sm: "6px 12px", md: "6px 12px" },
                          borderRadius: "15px",
                          fontWeight: 600,
                          transition: "all 0.3s ease",
                          "&:hover": {
                            background: "linear-gradient(45deg, #cc0029, #ff0037)",
                            transform: "translateY(-2px)",
                          },
                        }}
                      >
                        View Models
                        <FontAwesomeIcon
                          icon={faArrowRight}
                          style={{ marginLeft: "6px", fontSize: "0.6rem" }}
                        />
                      </Button>
                    </Card>
                  </Zoom>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Fade>

        {/* All Brands Section */}
        <Fade in={true} timeout={1000}>
          <Box>
            <Box sx={{ mb: { xs: 2, sm: 3, md: 4 } }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: { xs: 1, sm: 1.5, md: 2 },
                  mb: 2,
                }}
              >
                <FontAwesomeIcon
                  icon={faCar}
                  style={{
                    fontSize: "1.5rem",
                    color: "#ff0037",
                  }}
                />
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
                    color: "#333",
                  }}
                >
                  All Car Brands
                </Typography>
              </Box>
              <Box
                sx={{
                  width: { xs: "50px", sm: "60px", md: "80px" },
                  height: "4px",
                  background: "linear-gradient(45deg, #ff0037, #0066ff)",
                  borderRadius: "2px",
                  mb: 1,
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: "#666",
                  fontSize: { xs: "0.85rem", sm: "0.95rem", md: "1rem" },
                }}
              >
                Complete collection of automotive brands
              </Typography>
            </Box>

            <Grid container spacing={{ xs: 1.5, sm: 2, md: 2 }}>
              {nonPopularBrands.map((brand, index) => (
                <Grid item xs={4} sm={3} md={2} lg={1.5} key={`non-popular-${index}`}>
                  <Fade in={true} style={{ transitionDelay: `${index * 50}ms` }}>
                    <Card
                      className="all-brand-card"
                      onClick={() => handleBrandClick(brand.carBrandName)}
                      sx={{
                        cursor: "pointer",
                        height: { xs: "100px", sm: "120px", md: "140px" },
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#fff",
                        border: "2px solid #e9ecef",
                        borderRadius: "10px",
                        padding: { xs: 1, sm: 1.5, md: 2 },
                        transition: "all 0.3s ease-in-out",
                        "&:hover": {
                          boxShadow: "0 8px 20px rgba(0, 102, 255, 0.15)",
                          transform: "translateY(-4px)",
                          borderColor: "#0066ff",
                        },
                      }}
                    >
                      <CardMedia
                        component="img"
                        sx={{
                          height: { xs: "30px", sm: "35px", md: "40px" },
                          width: "auto",
                          objectFit: "contain",
                          mb: 0.5,
                        }}
                        image={allBrandImages(brand.carBrandName)}
                        alt={`${brand.carBrandName} logo`}
                      />
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: 600,
                          fontSize: { xs: "0.65rem", sm: "0.75rem", md: "0.8rem" },
                          color: "#333",
                          textAlign: "center",
                          textTransform: "uppercase",
                          lineHeight: 1.2,
                        }}
                      >
                        {brand.carBrandName.replace(/_/g, " ")}
                      </Typography>
                    </Card>
                  </Fade>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Fade>
      </Container>

      <Box sx={{ mt: { xs: "20%", sm: "15%", md: "10%", lg: "5%" } }}>
        <FooterManual />
      </Box>
    </Box>
  );
}